import { Component, OnInit } from '@angular/core';
import { UsefulLink } from '@box-types';
import { usefulLinks } from '@box-configs/useful-links.options';

@Component({
  selector: 'useful-links-menu',
  templateUrl: './useful-links-menu.component.html',
  styleUrls: ['./useful-links-menu.component.scss']
})
export class UsefulLinksMenuComponent implements OnInit {
  public menuItems: UsefulLink[];

  ngOnInit() {
    this.menuItems = usefulLinks;
  }
}
